import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {Button} from "react-bootstrap";
import './FinalModal.scss';
import ConfettiExplosion from '@reonomy/react-confetti-explosion';

/**
 * Component which shows the current best calculated result at the bottom of the page
 * @constructor
 */
export default function FinalModal() {
    const [confetti, setConfetti] = useState<boolean>(false);
    useEffect(() => {
        setConfetti(true);
    }, []);

    return <div className={'final-modal'}>
        <div className={'notification notification-success'}>
            <div className={'d-flex flex-column justify-content-center align-items-center'}>
                <FontAwesomeIcon icon={faCheck} size={'6x'} />
                {confetti && <ConfettiExplosion />}
            </div>
            <div className={'mt-4'}>
                <h1 className={'font-weight-bold'}>Super!</h1>
                <p>
                    Je hebt de simulatie succesvol volbracht en een offerte werd aangemaakt. Daarnaast ontvang je <b>&euro;100 korting</b>!<br /><br />
                    Een medewerker neemt snel contact met je op.<br /><br /><b>Tot dan!</b>
                </p>
            </div>
            <div className={'mt-4'}>
                <Button href={'https://www.kolu.be'} variant={'main'} size={'lg'} className={'float-right'}>Terug naar kolu.be &nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} /></Button>
            </div>
        </div>
    </div>;
}